/**
 * Termin-Logik:
 *  - Heutiger Tag ist nie buchbar
 *  - Buchung vor 16:00 Uhr: nächster Tag ist frühster Termin
 *  - Buchung um 16:00 Uhr oder später: übernächster Tag ist frühster Termin
 */
export const CUTOFF_HOUR = 16;

/** Format Date → YYYY-MM-DD basierend auf LOKALER Zeit (keine TZ-Verschiebung). */
export function toLocalDateString(date) {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Parse YYYY-MM-DD → Date um 12:00 Uhr LOKAL (verhindert TZ-Sprünge). */
export function parseLocalDateString(str) {
  if (!str) return undefined;
  const [y, m, d] = String(str).split("-").map(Number);
  if (!y || !m || !d) return undefined;
  return new Date(y, m - 1, d, 12, 0, 0, 0);
}

export function getEarliestBookingDate(now = new Date()) {
  const earliest = new Date(now);
  earliest.setHours(0, 0, 0, 0);
  // mindestens +1 Tag (heute nie verfügbar)
  earliest.setDate(earliest.getDate() + 1);
  // nach Cutoff: noch einen Tag weiter
  if (now.getHours() >= CUTOFF_HOUR) {
    earliest.setDate(earliest.getDate() + 1);
  }
  return earliest;
}

/** Liefert eine `disabled`-Funktion für das Calendar-Component. */
export function isDateDisabled(date, now = new Date()) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d < getEarliestBookingDate(now);
}

/** Kurzer User-Hinweis: warum heute/morgen ggf. nicht buchbar sind. */
export function getBookingHint(now = new Date()) {
  if (now.getHours() >= CUTOFF_HOUR) {
    return "Buchungen nach 16:00 Uhr: frühester Termin ist übermorgen.";
  }
  return "Heutiger Tag ist nicht verfügbar. Frühester Termin: morgen.";
}
